import { lazy, Suspense, useEffect, useState } from 'react';
import { scheduler } from '@/content/waq/book';
import { trackEvent } from '@/utils/analytics';
import type { BookingLink } from '@/api/bookings';
const BookingDialog = lazy(() => import('@/components/booking/BookingDialog'));

export function CallScheduler({ label = scheduler.label,
  className = 'flex w-full items-center justify-center gap-3 rounded-btn bg-yellow px-[30px] py-[19px] text-btn font-bold text-navy', onOpen,
}: { label?: string; className?: string; onOpen?: () => void } = {}) {
  const [open, setOpen] = useState(false);
  const [manage, setManage] = useState<BookingLink>();
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const id = params.get('booking'), key = params.get('key');
    if (id && key && window.location.pathname === '/contact') { setManage({ id, key }); setOpen(true); }
    else if (window.location.hash === '#schedule-call') setOpen(true);
  }, []);
  const close = () => { setOpen(false); setManage(undefined); if (window.location.hash.includes('booking=') || window.location.hash === '#schedule-call') window.history.replaceState(null, '', window.location.pathname + window.location.search); };
  return <>
    <button type="button" className={className} onClick={() => { setOpen(true); trackEvent('schedule_call_click', { location: window.location.pathname }); onOpen?.(); }}>
      {label}<span aria-hidden="true">→</span>
    </button>
    {open && <Suspense fallback={<p role="status" className="mt-3 text-sm">Opening calendar…</p>}><BookingDialog onClose={close} manage={manage} /></Suspense>}
  </>;
}
